<template>
  <div class="ui-content">
    <div class="ui-seachBox">
      <el-row class="row-bg">
        <el-col :span="8">
          <p class="ui-seachBox-label">
            <span>姓名</span>
            <span class="ui-seachBox-Symbol">:</span>
          </p>
          <el-input class="ui-seachBox-input" v-model="seach.tbName" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="8">
          <p class="ui-seachBox-label">
            <span>手机</span>
            <span class="ui-seachBox-Symbol">:</span>
          </p>
          <el-input class="ui-seachBox-input" v-model="seach.tbPhone" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="8">
          <p class="ui-seachBox-label">
            <span>五色管理</span>
            <span class="ui-seachBox-Symbol">:</span>
          </p>
          <el-select class="ui-seachBox-input" v-model="seach.riskLevel" placeholder="请选择" clearable>
            <el-option v-for="item in riskLevelList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="row-bg">
        <el-col :span="8">
          <p class="ui-seachBox-label">
            <span>胎心监护</span>
            <span class="ui-seachBox-Symbol">:</span>
          </p>
          <el-select class="ui-seachBox-input" v-model="seach.scoreType" placeholder="请选择" clearable>
            <el-option v-for="item in tbScoreList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <p class="ui-seachBox-label">
            <span>异常指标</span>
            <span class="ui-seachBox-Symbol">:</span>
          </p>
          <el-select class="ui-seachBox-input" v-model="seach.abnormalType" placeholder="请选择" clearable>
            <el-option v-for="item in abnormalTypeList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <p class="ui-seachBox-label">
            <span>所在医院</span>
            <span class="ui-seachBox-Symbol">:</span>
          </p>
          <el-select class="ui-seachBox-input" filterable v-model="seach.hospitalId" placeholder="请选择" clearable>
            <el-option v-for="item in hospitalList" :key="item.tbId" :label="item.tbHospitalName" :value="item.tbId">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="row-bg">
        <el-button class="ui-seachBox-submit" type="primary" @click="getList">查 询</el-button>
        <el-button class="ui-seachBox-reset" @click="reset">重 置</el-button>
      </el-row>
    </div>
    <div class="ui-tableBox">
      <div class="ui-tableBox-bar">
        <p class="ui-tableBox-title">数据列表</p>
      </div>
      <div class="ui-tableList">
        <el-table v-loading="loading" :data="tableList" :max-height="tableHeight" :default-sort="{prop: 'tbSort', order: 'ascending'}" border style="width: 100%" :header-cell-style="{background: '#FAFAFA'}">
          <el-table-column align="center" type="index" width="68px" label="序号">
          </el-table-column>
          <el-table-column align="center" prop="username" label="姓名" width="120px">
          </el-table-column>
          <el-table-column align="center" label="年龄" width="90px">
            <template slot-scope="{row}">
              {{row.birthday && (calculateAge(row.birthday) + '岁')}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="phone" label="手机" width="150px">
          </el-table-column>
          <el-table-column align="center" prop="tbHospitalName" label="医院" width="180px">
          </el-table-column>
          <el-table-column align="center" prop="week" label="孕周" width="130px">
            <template slot-scope="{row}">
              {{row.currentGeneration ==1 ? row.week:'已出生'}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="tbRiskLevel" label="五色管理" width="150px">
            <template slot-scope="{row}">
              <div v-if="!row.tbRiskLevel">暂无</div>
              <div v-else class="block">
                <div v-if="row.tbRiskLevel[0] === '1'" class="ui-box-tableList-block" style="background:#6DD400;">绿色</div>
                <div v-else-if="row.tbRiskLevel[0] === '2'" class="ui-box-tableList-block" style="background:#F7B500;">黄色</div>
                <div v-else-if="row.tbRiskLevel[0] === '3'" class="ui-box-tableList-block" style="background:#FA6400;">橙色</div>
                <div v-else-if="row.tbRiskLevel[0] === '4'" class="ui-box-tableList-block" style="background:#E02020;">红色</div>
                <template v-else-if="row.tbRiskLevel[0] === '5'">
                  <div v-if="row.tbRiskLevel[1] === '1'" class="ui-box-tableList-block" style="background:#6DD400;">绿色</div>
                  <div v-if="row.tbRiskLevel[1] === '2'" class="ui-box-tableList-block" style="background:#F7B500;">黄色</div>
                  <div v-if="row.tbRiskLevel[1] === '3'" class="ui-box-tableList-block" style="background:#FA6400;">橙色</div>
                  <div v-if="row.tbRiskLevel[1] === '4'" class="ui-box-tableList-block" style="background:#E02020;">红色</div>
                  <div class="ui-box-tableList-block" style="background:#7E61F4;">紫色</div>
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="tbRiskTime" label="评估时间" width="150px">
            <template slot-scope="{row}">
              {{row.tbRiskTime? new Date(row.tbRiskTime).format('yyyy-MM-dd') :'暂无'}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="createtime" label="注册时间" width="150px">
            <template slot-scope="{row}">
              {{row.createtime? new Date(row.createtime).format('yyyy-MM-dd') :'暂无'}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="tbScore" label="胎心监护" width="150px">
            <template slot-scope="{row}">
              <el-link class="ui-tableList-link" @click="openTab('胎心历史','heart',`/patient/heart`,{tbId:row.id,week:row.currentGeneration ==1 ? row.week:'已出生'})">{{row.tbScore? row.tbScore+'分' :'暂无'}}</el-link>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="abnormalVal" label="其他异常指标">
            <template slot-scope="{row}">
              {{row.abnormalVal? row.abnormalVal :'暂无'}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="name" label="操作" width="250px">
            <template slot-scope="{row}">
              <el-row>
                <el-col :span="12">
                  <el-link class="ui-tableList-link" @click="openTab('患者详情','userDetail',`/fetalMonitor/userDetail`,{tbId:row.id})">查看详情</el-link>
                  <!-- <el-link class="ui-tableList-link" @click="openTab('监护数据','monitor',`/heart/mother/monitor`,{tbId:row.id,week:row.currentGeneration ==1 ? row.week:'已出生'})">查看详情</el-link> -->
                </el-col>
                <el-col :span="12">
                  <el-link class="ui-tableList-link" @click="addChatMother(row)">发消息</el-link>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination class="ui-papagination" @size-change="page.pagingSizeChange" @current-change="page.pagingCurrentChange" :total="page.total" :pageSizes="page.pageSizes" :pageSize="page.pageSize" :currentPage="page.currentPage"></pagination>
    </div>
  </div>
</template>
<script>

const suffixList = ['patient']
let fileName = 'patient'
const controller = 'user'
import { debounceUtils } from '@/utils/common.js'
import { mapGetters, mapActions } from 'vuex'
import cal from '@/utils/calculation';
export default {
  name: `${suffixList.join('')}${fileName}`,
  props: {
    hireState: Number,
  },
  data () {
    const _this = this
    return {
      filePath: ['', ...suffixList, fileName].join('/'),
      fileName: '',
      detailName: `${fileName}Detail`,
      jaundiceData: [
        [0, 0],
        [3, 0],
        [10, 1.5],
        [20, 3.3],
        [30, 4.9],
        [40, 6.1],
        [50, 7.1],
        [60, 7.9],
        [70, 8.5],
        [80, 9.0],
        [90, 9.4],
        [100, 9.6],
        [110, 9.8],
        [120, 10.0],
        [130, 9.9],
        [140, 9.7],
        [150, 9.4],
        [160, 9.1],
        [168, 8.8],
        [720, 8.8]
      ],
      abnormalTypeList: [
        { id: '1', name: '心率' },
        { id: '2', name: '血糖' },
        { id: '3', name: '血氧' },
        { id: '4', name: '血压' },
        { id: '5', name: '黄疸' },
        { id: '6', name: '体温' },
        { id: '7', name: '尿酸' },
        { id: '8', name: '血脂' },
      ],
      riskLevelList: [
        { id: '1', name: '低风险' },
        { id: '2', name: '一般风险' },
        { id: '3', name: '较高风险' },
        { id: '4', name: '高风险' },
        { id: '5', name: '传染性疾病' },
      ],

      loading: true,
      tableHeight: null,
      page: {
        currentPage: 1, //当前页
        pageSize: 10, //每页记录数
        total: 10,
        pageSizes: [10, 20, 50, 100],
        pagingSizeChange (value) {
          _this.page.currentPage = 1
          _this.page.pageSize = value
          _this.getList()
        },
        pagingCurrentChange (value) {
          _this.page.currentPage = value
          _this.getList()
        }
      },
      tbScoreList: [{ id: 1, name: '0-4分' }, { id: 2, name: '5-7分' }, { id: 3, name: '8-10分' }],
      tableList: [],
      hospitalList: [],
      seach: {
        hospitalId: '',
        tbName: '',
        tbPhone: '',
        riskLevel: '',
        scoreType: '',
        abnormalType: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'chatShow',
      'lastBreadCrumb',
      'refreshPage'
    ])
  },
  watch: {
    $route (to, from) {
      if (to.path === this.filePath && this.refreshPage) {
        this.getList()
        this.$store.dispatch('setRefreshPage', false)
      }
    }
  },
  methods: {
    ...mapActions([
      "onGetContactUserList"
    ]),
    getHospitalList () {
      this.$http.get(`/hospital/findByParentId`, { tbId: this.$route.query.hId }).then((res) => {
        if (res.code === 1000) {
          this.hospitalList = res.data
        }
      })
    },
    addChatMother (row) {
      const userInfo = localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo'));
      const item = {
        conversationId: row.tbUuid,
        conversationType: "singleChat",
        isPinned: false,
        lastMessage: { id: '', type: 'txt', chatType: 'singleChat', msg: '', ext: {}, to: row.tbUuid, from: userInfo?.userId, time: new Date().getTime() },
        pinnedTime: 0,
        unReadCount: 0
      }
      this.$store.dispatch('onGetContactUserList', item);
      if (!this.chatShow) {
        this.$store.commit('SET_CHAT_SHOW', true)
      }
    },
    del (id) {
      this.msgboxMixin(() => {
        this.$http.post(`/${controller}/delete`, [{ 'tbId': id }])
          .then(res => {
            if (res.code === 1000) {
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          })
      })
    },
    calculateAge (birthDate) {
      birthDate = new Date(birthDate)
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      // 如果当前月份小于出生月份，或者月份相同但日期小于出生日期，则年龄减1
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    reset () {
      this.seach = {
        hospitalId: '',
        tbName: '',
        tbPhone: '',
        riskLevel: '',
        scoreType: '',
        abnormalType: ''
      }
    },
    getList: debounceUtils(function () {
      this.loading = true
      this.seach.page = this.page.currentPage
      this.seach.size = this.page.pageSize
      this.seach.parentHospitalId = this.$route.query.hId
      this.seach.hireState = this.hireState
      this.$http.get(`/${controller}/findListByParentHospitalId`, this.seach)
        .then(res => {
          this.loading = false
          if (res.code === 1000) {
            this.tableList = res.data.list.map(i => {
              if (i.tbRiskLevel) {
                i.tbRiskLevel = Array.from(new Set(i.tbRiskLevel.split(','))).sort((a, b) => b - a)
              }
              i.abnormalVal = ''
              if (i.tbJaundiceValue && i.tbJaundiceBirthday) {
                if (this.getJaundiceColor(i.tbJaundiceValue, i.tbJaundiceCreateTime, i.tbJaundiceBirthday)) {
                  i.abnormalVal += '黄疸，'
                }
              }
              if (i.tbHeartRate) {
                if (i.tbHeartRate > 99 || 61 > i.tbHeartRate) {
                  i.abnormalVal += '心率，'
                }
              }
              if (i.tbBloodGlucose) {
                if (i.tbBloodGlucose > 5.1 || 3.1 > i.tbBloodGlucose) {
                  i.abnormalVal += '血糖，'
                }
              }
              if (i.tbBloodOxygen) {
                if (95 > i.tbBloodOxygen) {
                  i.abnormalVal += '血氧，'
                }
              }
              if (i.tbBloodPressure) {
                const systolic = i.tbBloodPressure.split('/')[0]
                const diastolic = i.tbBloodPressure.split('/')[1]
                if (systolic > 139 || diastolic > 89 || 90 > systolic || 60 > diastolic) {
                  i.abnormalVal += '血压，'
                }
              }
              if (i.tbTemperature) {
                if (i.tbTemperature > 37.3) {
                  i.abnormalVal += '体温，'
                }
              }
              if (i.tbUricAcid) {
                if (i.tbUricAcid < 60 || i.tbUricAcid > 360) {
                  i.abnormalVal += '尿酸，'
                }
              }
              if (i.tbBloodFat) {
                if (i.tbBloodFat > 5.2) {
                  i.abnormalVal += '血脂，'
                }
              }
              i.abnormalVal = i.abnormalVal.length > 0 ? i.abnormalVal.substr(0, i.abnormalVal.length - 1) : i.abnormalVal
              return i
            })
            this.page.total = res.data.total
          } else {
            this.$message.error(res.message)
          }
        })
    }, 500),
    getJaundiceColor (val, createTime, birthday) {
      let time = Math.abs(new Date(createTime.replace(/-/g, '/')).getTime() - new Date(birthday.replace(/-/g, '/')).getTime())
      const day = Math.floor(time / 1000 / 60 / 60 / 24)
      const hour = Math.floor((time - day * 24 * 60 * 60 * 1000) / 1000 / 60 / 60) + 1
      time = 24 * day + hour
      time = time > 720 ? 720 : time
      const index = this.jaundiceData.findIndex(([x, y], index) => time <= x, 0)
      return this.isJaundiceArea(time, val, index, 'jaundiceData')
    },
    isJaundiceArea (x, y, index, label) {
      const [x1, y1] = this[label][index - 1]
      const [x2, y2] = this[label][index]
      const temp = cal.accMul(cal.accDiv(cal.accSub(y2, y1), cal.accSub(x2, x1)), cal.accSub(x, x2))
      return cal.accSub(cal.accAdd(temp, y2), y) < 0
    },
  },
  destroyed () {
    this.destroyResizeListen(556)
  },
  created () {
    this.addResizeListen(556)
  },
  mounted () {
    this.getList()
    this.getHospitalList()
  },
  components: {
  }
}
</script>

<style lang="scss" scoped>
.ui-content {
  width: 100%;
  height: 100%;
  .ui-seachBox {
    margin: 0 24px 24px;
    width: calc(100% - 48px);
    height: 192px;
    background: #ffffff;
    border-radius: 2px;
    .row-bg {
      padding: 24px 24px 0;
      .ui-seachBox-label {
        display: inline-block;
        text-align: right;
        width: 100px;
        height: 22px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 32px;
        vertical-align: top;
      }
      .ui-seachBox-label2 {
        display: inline-block;
        text-align: right;
        height: 22px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 32px;
        vertical-align: top;
        margin-right: 10px;
      }
      .ui-seachBox-box-switch {
        height: 32px;
        line-height: 32px;
        vertical-align: top;
      }
      .ui-seachBox-Symbol {
        margin-left: 3px;
        margin-right: 5px;
      }
      .ui-seachBox-input {
        display: inline-block;
        width: calc(100% - 100px);
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        padding-top: 0;
        padding-bottom: 0;
        vertical-align: middle;
        ::v-deep .el-icon-circle-close,
        ::v-deep .el-icon-arrow-up,
        ::v-deep .el-icon-date,
        ::v-deep .el-range__icon,
        ::v-deep .el-range-separator,
        ::v-deep .el-range-input,
        ::v-deep .el-range__close-icon,
        ::v-deep .el-input__inner {
          vertical-align: top;
          height: 30px;
          line-height: 30px;
          border: none;
        }
      }
      .ui-seachBox-box-label {
        display: inline-block;
        width: calc(100% - 100px);
        height: 32px;
        line-height: 32px;
      }
    }
    .ui-seachBox-reset {
      margin: 0 0 0 8px;
      float: right;
      border-radius: 2px;
      padding: 9px 15px;
      &:focus {
        outline: none;
      }
    }
    .ui-seachBox-submit {
      padding: 9px 15px;
      margin: 0 0 0 8px;
      float: right;
      border-radius: 2px;
      &:focus {
        outline: none;
      }
    }
  }
  .ui-tableBox {
    margin: 0 24px;
    width: calc(100% - 48px);
    background: #ffffff;
    border-radius: 2px;
    height: calc(100% - 240px);
    position: relative;
    .ui-tableBox-bar {
      position: relative;
      margin: 0 24px;
      height: 64px;
      .ui-tableBox-title {
        height: 24px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 24px;
        display: inline-block;
        margin-top: 20px;
      }
      .ui-tableBox-button {
        width: 108px;
        position: relative;
        float: right;
        top: 16px;
        margin-left: 24px;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        &.export {
          padding: 8px 15px;
          width: auto;
        }
        ::v-deep .el-icon-arrow-up,
        ::v-deep .el-input__inner {
          height: 30px;
          line-height: 30px;
          border: none;
          &::-webkit-input-placeholder {
            color: #606266;
          }
          &::-moz-placeholder {
            color: #606266;
          }
          &::-ms-input-placeholder {
            color: #606266;
          }
        }
        &:focus {
          outline: none;
        }
      }
    }
    .ui-tableList {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;
      margin: 8px 24px 0 24px;
      .block {
        display: flex;
        justify-content: center;
        .ui-box-tableList-block {
          margin: 0 5px;
          width: 44px;
          height: 22px;
          border-radius: 2px;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          line-height: 22px;
          text-align: center;
        }
      }

      .ui-box-tableList-img {
        width: 80px;
        height: 80px;
        background: #d8d8d8;
        display: inline-block;
        vertical-align: top;
      }
      .ui-box-tableList-label {
        margin: 0 5px 10px;
      }
      .ui-box-tableList-editImg {
        width: 43px;
        cursor: pointer;
        height: 43px;
      }
      .ui-box-tableList-tempSaveImg {
        width: 41px;
        height: 41px;
        position: absolute;
        left: -2px;
        top: -3px;
      }
      ::v-deep .el-table__body-wrapper {
        height: auto !important;
      }
      .ui-tableList-button {
        padding: 9px 17px;
        outline: none;
      }
      .ui-tableList-link {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1890ff;
      }
      .ui-tableList-link.is-underline:hover:after {
        border: none;
      }
    }
  }
}
</style>